import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface Code {
  percent: number;
  publisher_id: number;
  active?: boolean;
  limit: number;
  count?: number;
  sub_plan_id?: string; // plan ID or ANY so it can be used on any subscription plan from the publisher
}

@Injectable()
export class DiscountCodesService {
  private http = inject(HttpClient);


  getPublicProfile(accountId: number): Promise<any> {
    return firstValueFrom(this.http.get<any>(`/api/account/${accountId}/public/profile`));
  }

  getRedemptionPublishers(accountId: number): Promise<any> {
    return firstValueFrom(this.http.get<any>('/api/util/redemption/code/publishers'));
  }

  getRedemptionCodeList(accountId: number): Promise<any> {
    return firstValueFrom(this.http.get<any>(`/api/account/${accountId}/redemption_code/list`));
  }

  createSingleCode(accountId: number, code: string, codeDetails: Code): Promise<any> {
    return firstValueFrom(this.http.put<any>(`/api/account/${accountId}/redemption_code/set/${code}`, codeDetails));
  }

  createBatchOfCodes(accountId: number, codeDetails: Code): Promise<any> {
    return firstValueFrom(this.http.put<any>(`/api/account/${accountId}/redemption_code/generate`, codeDetails));
  }

  verifyCode(accountId: number, code: string | number): Promise<any> {
    return firstValueFrom(this.http.get(`/api/account/${accountId}/redemption_code/verify/${code}`));
  }

  deleteDiscountCode(accountId: number, code: string | number): Promise<any> {
    return firstValueFrom(this.http.delete(`/api/account/${accountId}/redemption_code/remove/${code}`));
  }
}
